import { _ as __rest, a as __assign } from '../../tslib.es6-18cb2814.js';
import { c as classNames } from '../../index-8887fc24.js';
import * as React from 'react';

var styles = {"container":"HighlightText_container_a6a256c3"};

var HighlightText = React.forwardRef(function HighlightText(props, ref) {
    var className = props.className, search = props.search, children = props.children; props["data-testid"]; var otherProps = __rest(props, ["className", "search", "children", "data-testid"]);
    var highlighted = React.Children.map(children, function (child) {
        if (typeof child === "string" && search) {
            try {
                // Create regex from search text
                var searchRe = new RegExp(search, "ig");
                var res = null;
                var lastIndex = 0;
                var highlightChild = [];
                // Loop over matches and build jsx
                while ((res = searchRe.exec(child)) !== null) {
                    // Get first portion
                    highlightChild.push(child.slice(lastIndex, res.index));
                    // Wrap matched portion in <mark />
                    highlightChild.push(React.createElement("mark", null, child.slice(res.index, res.index + res[0].length)));
                    // Update last index for next iteration
                    lastIndex = searchRe.lastIndex;
                }
                // Remaining text
                highlightChild.push(child.slice(lastIndex));
                return highlightChild;
            }
            catch (err) {
                // If we can't create a regex from the search text, render the child as normal, without highlighting
                return child;
            }
        }
        return child;
    });
    return (React.createElement("span", __assign({ ref: ref, className: classNames(styles.container, className) }, otherProps, { "data-testid": "highlight-text" }), highlighted));
});

export { HighlightText };
